export default class DateUtils {
	months = [
		'Styczeń',
		'Luty',
		'Marzec',
		'Kwieceń',
		'Maj',
		'Czerwiec',
		'Lipiec',
		'Sierpień',
		'Wrzesień',
		'Październik',
		'Listopad',
		'Grudzień',
	];

	static dates = (...dates) => dates.map(date => new Date(date));

	static date = date => new Date(date);

	static getMonths = () => months;

	static from = (year, month, day = 1) => new Date(year, month, day);

	static object = date => {
		return {
			month: this.date(date).getMonth(),
			year: this.date(date).getFullYear(),
			day: this.date(date).getDate(),
		};
	};

	static daysBetween(date1, date2) {
		const days = [];
		for (
			let day = new Date(date1);
			day <= date2;
			day.setDate(day.getDate() + 1)
		) {
			days.push(new Date(day));
		}
		return days;
	}

	static isSameMonth = (date1, date2) => {
		const { year: year1, month: month1 } = this.object(date1);
		const { year: year2, month: month2 } = this.object(date2);
		return year1 === year2 && month1 === month2;
	};

	static isSameDay = (date1, date2) => {
		const { year: year1, month: month1, day: day1 } = this.object(date1);
		const { year: year2, month: month2, day: day2 } = this.object(date2);
		return year1 === year2 && month1 === month2 && day1 === day2;
	};

	static monthInputPattern = (year, month) =>
		`${String(year)}-${String(month + 1).padStart(2, '0')}`;

	static dateInputPattern = date => {
		const { year, month, day } = this.object(date);
		const dayMarkup = String(day).padStart(2, '0');
		const monthMarkup = String(month + 1).padStart(2, '0');
		const yearMarkup = String(year);
		return `${yearMarkup}-${monthMarkup}-${dayMarkup}`;
	};

	static daysInMonth = (year, month) => this.from(year, month + 1, 0).getDate();

	static prevMonth(year, month) {
		const prevYear = month === 0 ? year - 1 : year;
		const prevMonth = month === 0 ? 11 : month - 1;
		return { prevYear, prevMonth };
	}

	static nextMonth(year, month) {
		const nextYear = month === 11 ? year + 1 : year;
		const nextMonth = month === 11 ? 0 : month + 1;
		return { nextYear, nextMonth };
	}

	static nextYearDate = (date, increase = 1) =>
		new Date(date).setFullYear(date.getFullYear() + increase);
}
